export const RequestFailureMessage = 'Request failed. Please try again!'
export const PatchMilestonesDataFailureMessage =
  'Failed to update milestone as done.'
export const SyncStatusFail = 'Sync update failed.'
export const PartnerUpdateSuccess = 'Partner updated successfully.'
export const PartnerUpdateError =
  'There was an error trying to update the partner'
export const S3ConnectionSuccessMessage = 'S3 connected successfully.'
export const S3ConnectionFailureMessage = 'S3 connection failed.'
export const MeteringSuccessMessage = 'Metering record submitted successfully.'
export const MeteringFailureMessage =
  'Metering was not submitted. Please try again.'
export const DefaultSuccesrOnSubmitData = 'Successfully submitted'
export const freeTrialRequestSuccess =
  'Free Trial request received successfully. You will be notified on email once it is live.'
export const freeTrialRequestUnsuccess =
  'Free Trial request failed. Please try again.'
export const freeTrialOfferIdPatchRequestSuccess =
  'Offer ID updated succesfully.'
export const freeTrialOfferIdPatchRequestUnsuccess =
  'Failed to update Offer ID.'
export const freeTrialDeactivateRequestSuccess =
  'Free Trial deactivation request received successfully. You will be notified on email once it is deactivated.'
export const freeTrialDeactivateRequestUnsuccess =
  'Free Trial deactivation request failed. Please try again.'
export const productStatusUpdateSuccessMessage =
  'Status updated to Active sucessfully'
export const UploadToS3Unsuccessful = 'Error while uploading eula files'
export const enterQuantityMsg = 'Please enter quantity.'
export const quantityNegativeMsg = 'Quantity cannot be negative.'
export const quantityDecimalMsg = 'Quantity cannot take decimal values.'
export const quantityMoreThan0Msg = 'Quantity should be greater than 0.'
export const syncReceivedResaleAuthSuccessMessage =
  'Received resale authorizations sync initiated successfully.'
export const UserUpdationSuccessMessage = 'User profile successfully updated.'
export const UserUpdationFailureMessage = 'Error while updating user.'
export const AddUserRequestSuccess =
  'Invitation sent successfully to all the users.'
export const InviteUserRequestSuccess =
  'Invitation sent successfully to the user.'
export const InviteUserUpdateRequestSuccess =
  'User details updated successfully.'
export const CRMAuthSuccessMessage =
  'Your CRM connection is authenticated and linked now.'
export const ssoInviteDisableMessage =
  'Please ask your SSO admin to invite the team members to ensure they have the appropriate permissions and access.'
